import {ReactNode} from 'react'
import { useLocation } from 'react-router-dom'
import cn from 'clsx'
import {Image, Space} from 'antd'

import styles from './ProjectCard.module.scss'
import xeroImg from 'assets/images/xero.png'
import useStore from 'base/store'
import {
  ManagerAssignForm,
  BrokerAssignForm,
  BorrowerAssignForm,
  // isMilestonePassed,
} from 'modules/request'
import {
  Block,
  Text,
  Button,
  Confirm,
  Modal,
  UserAvatar,
  IconButton,
  EyeIcon, PenEditThirdIcon,
} from 'common/components'
import {useOpen} from 'common/hooks'
import {
  BorrowerProjectTag,
  useSyncProjectXero,
  isProjectRequest,
  PROJECT_CATEGORY_NAME,
  ProjectCategory,
} from '..'

interface ProjectCardProps {
  children?: ReactNode
  project: any
  request?: any
  isRequestLoading?: any
  imgHeight: number
}

interface OrgItemProps {
  item: any
}
interface MemberItemProps {
  item: any
  error?: boolean
}

// interface UserItemProps {
//   showRole?: boolean
//   user: any
//   rating?: number
// }

export interface IManagerProps {
  uuid: string;
  displayId: number;
  email: string;
  firstName?: string;
  lastName?: string;
  photo?: string;
}
interface ManagerAssignProps {
  request?: any
  projectUuid: string
  isRequestLoading: boolean
  manager?: IManagerProps
  almList?: IManagerProps[]
}

interface BrokerAssingProps {
  projectUuid: string
  request: any
  isRequestLoading: boolean
  broker: any
  org?: any
  members?: any
}

interface DisplayIDProps {
  displayId: number
}

export default function ProjectCard({
  children,
  project,
  request,
  isRequestLoading,
  imgHeight,
}: ProjectCardProps) {
  const permissions = useStore((state) => state.permissions)
  const role = useStore((state) => state.role)
  // console.log(project)
  // console.log(request)
  const borrower = project?.borrower
  const borrowerPersons = project?.borrowerPersons
  const broker = project?.broker
  const brokerPersons = project?.brokerPersons
  // const isBroker = Boolean(broker)
  // const isActiveProject =
  //   project.status !== 'declined' && project.status !== 'declined'

  return (
    <Block
      type={role.user ? undefined : 'white'}
      className={cn(styles.root, role.user && styles.root_borrower)}
    >
      <Image
        width="100%"
        height={imgHeight}
        src={project?.image}
        alt={project?.title}
      />
      <div className={styles.block}>
        <div className={styles.panel}>
          {role.user ? (
            isProjectRequest(project) ? (
              <BorrowerProjectTag project={project} />
            ) : (
              <DisplayID displayId={project?.displayId} />
            )
          ) : (
            <>
              <DisplayID displayId={project?.displayId} />
              { (project?.status === 'opened') && 
                !!permissions?.includes('sync with xero') &&
                (
                  <XeroButton projectUuid={project?.uuid} />
                )}
            </>
          )}
        </div>
        <Text as="h3" size="3xl" weight="medium" mb={12}>
          {project?.title}
        </Text>
        <Text color="grey" mb={6}>
          {project?.categories?.map(
            (category: ProjectCategory) => PROJECT_CATEGORY_NAME[category]
          ).join(', ')}
        </Text>
        <Text color="grey">{project?.address}</Text>
      </div>
      <div className={cn(styles.block, styles.block_users)}>
        <div className={styles['member-assign']}>
          <Text size='2xs' weight='demiBold'>BORROWER</Text>
          <BorrowerAssign
            request={request}
            projectUuid={project?.uuid}
            isRequestLoading={isRequestLoading}
            org={borrower}
            members={borrowerPersons}
          />
        </div>
        <OrgItem item={borrower} />
        { borrowerPersons?.Editor?.map((x:any, index:number) => (
          <MemberItem key={index} item={{
            name: `${x.firstName} ${x.lastName}`,
            role: 'editor',
            photo: x.photo,
          }} />
        )) }
        { borrowerPersons?.Viewer?.map((x:any, index:number) => (
          <MemberItem key={index} item={{
            name: `${x.firstName} ${x.lastName}`,
            role: 'viewer',
            photo: x.photo,
          }} />
        )) }
        <div className={styles['member-assign']}>
          <Text size='2xs' weight='demiBold'>BROKER</Text>
          <BrokerAssign
            request={request}
            broker={{}}
            projectUuid={project?.uuid}
            isRequestLoading={isRequestLoading}
            org={broker}
            members={brokerPersons}
          />
        </div>
        <OrgItem item={broker} />
        { brokerPersons?.Editor?.map((x:any, index:number) => (
          <MemberItem key={index} item={{
            name: `${x.firstName} ${x.lastName}`,
            role: 'editor',
            photo: x.photo,
          }} />
        )) }
        { brokerPersons?.Viewer?.map((x:any, index:number) => (
          <MemberItem key={index} item={{
            name: `${x.firstName} ${x.lastName}`,
            role: 'viewer',
            photo: x.photo,
          }} />
        )) }
        <div className={styles['member-assign']}>
          <Text size='2xs' weight='demiBold'>VC Team</Text>
          <ManagerAssign
            request={request}
            manager={project?.manager}
            almList={project?.assistantLendingManagers || []}
            projectUuid={project?.uuid}
            isRequestLoading={isRequestLoading}
          />
        </div>
        <MemberItem item={project?.manager} />
        { project?.assistantLendingManagers?.map((x:any, index:number) => (
          <MemberItem key={index} item={x} />
        )) }
      </div>
      {/* {!role.user && (
        <div className={cn(styles.block, styles.block_users)}>
          <div className={styles.userWrapper}>
            <UserItem
              showRole={isBroker}
              user={borrower}
              rating={borrower?.borrower?.rating}
            />
            {role.manager &&
              isActiveProject &&
              request &&
              request.milestones.some(
                (milestone: any) => milestone.type === 'borrower-assigned'
              ) &&
              !isMilestonePassed('borrower-assigned', request) && (
                <BorrowerAssign
                  projectUuid={project.uuid}
                  isRequestLoading={isRequestLoading}
                />
              )}
          </div>
          <div className={styles.userWrapper}>
            {project.manager && (
              <UserItem
                showRole={isBroker}
                user={project.manager}
                rating={project.manager.manager.rating}
              />
            )}
            {role.coordinator && isActiveProject && (
              <ManagerAssign
                request={request}
                projectUuid={project.uuid}
                manager={project.manager}
                isRequestLoading={isRequestLoading}
              />
            )}
          </div>
          {isBroker && (
            <div className={styles.userWrapper}>
              {project.brokerProfile ? (
                <BrokerItem broker={broker} />
              ) : (
                <UserItem showRole user={broker} />
              )}
              {role.manager && isActiveProject && (
                <BrokerAssign
                  projectUuid={project.uuid}
                  broker={broker}
                  isRequestLoading={isRequestLoading}
                />
              )}
            </div>
          )}
        </div>
      )} */}
      {children}
    </Block>
  )
}

const AssignRoleController = ({children, request}:{
  children: React.ReactNode
  request: any
}) => {
  const permissions = useStore((state) => state.permissions)
  const {pathname} = useLocation()
  const isLoanRequest = (pathname.indexOf('/requests/loan/') > -1)
  const isAllowed = (
    !!permissions?.includes('assign orgs') ||
    (
      (!!isLoanRequest) &&
      (!!permissions?.includes('assign orgs (specific scenarios)')) && 
      ([
        'lending-manager-check',
        'financial-controller-check',
        'director-check',
        'approved'  // sign the contract
      ].includes(request?.status))
    )
  )
  return (
    !isAllowed ? null :
    <>
      {children}
    </>
  )
}
const ManagerAssign = ({
  request,
  projectUuid,
  isRequestLoading,
  manager,
  almList,
}: ManagerAssignProps) => {
  const isManagerAssignOpen = useStore((state) => state.isManagerAssignOpen)
  const setManagerAssignOpen = useStore((state) => state.setManagerAssignOpen)

  const handleOpen = () => setManagerAssignOpen(true)
  const handleClose = () => setManagerAssignOpen(false)

  return (
    <AssignRoleController request={request}>
      <Button
        variant="v2"
        disabled={isRequestLoading}
        onClick={handleOpen}
      >
        edit
      </Button>
      <Modal
        title={`Associate with lending manager`}
        open={isManagerAssignOpen}
        // onCancel={handleClose}
      >
        <ManagerAssignForm
          request={request}
          projectUuid={projectUuid}
          manager={manager}
          almList={almList}
          onClose={handleClose}
        />
      </Modal>
    </AssignRoleController>
  )
}

const OrgItem = ({item}: OrgItemProps) => {
  return (
    !item?.name ? null :
    <Space className={styles.org} size={6}>
      <UserAvatar
        src={item.photo}
        size={32}
        alt={(item.name ?? item.firstName) || 'org'}
      />
      <Text as="span" size="md" weight="demiBold">
        {item?.name}
      </Text>
    </Space>
  )
}

const MemberItem = ({item, error}: MemberItemProps) => {
  return (
    !item ? null :
    <div className={styles.member}>
      <Space className={styles['member-info']} size={10}>
        <UserAvatar
          src={item.photo}
          size={24}
          alt={(item.name ?? `${item.firstName} ${item.lastName}`) || 'member'}
        />
        <Text as="span" size="md" color={!!error ? "brown":"black"}>
          {item.name ?? `${item.firstName} ${item.lastName}`}
        </Text>
      </Space>
      <div className={styles['member-icon']}>
      { (item.role === 'viewer') ?
        <EyeIcon /> :
        (item.role === 'editor') ?
        <PenEditThirdIcon /> :
        null
      }
      </div>

    </div>
  )
}

// const UserItem = ({showRole, user, rating}: UserItemProps) => {
//   return (
//     <Space className={styles.user} size={6}>
//       <UserAvatar
//         src={user.photo}
//         size={32}
//         alt={user.name ?? user.firstName}
//       />
//       <div>
//         <p>
//           <Text as="span" weight="demiBold">
//             {user.name ?? `${user.firstName} ${user.lastName}`}
//           </Text>
//           {rating !== undefined && (
//             <Text as="span" size="xs" weight="bold" color="greenLight" ml={6}>
//               {rating}
//             </Text>
//           )}
//         </p>
//         {showRole && (
//           <Text color="grey" size="xs">
//             {user.manager
//               ? 'lending manager'
//               : user.borrower
//               ? 'borrower'
//               : user.email}
//           </Text>
//         )}
//       </div>
//     </Space>
//   )
// }

// const BrokerItem = ({broker}: any) => {
//   const [user] = broker.users

//   return (
//     <Space className={styles.user} size={6}>
//       <UserAvatar src={user.photo} size={32} alt={user.firstName} />
//       <div>
//         <Text weight="demiBold">
//           {user.firstName} {user.lastName}
//         </Text>
//         <Text color="grey" size="xs">
//           broker #{broker.licenceNumber}
//         </Text>
//       </div>
//     </Space>
//   )
// }

const BrokerAssign = ({
  broker,
  request,
  projectUuid,
  isRequestLoading,
  org, members,
}: BrokerAssingProps) => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  const isBroker = Boolean(broker.uuid)

  return (
    <AssignRoleController request={request}>
      <Button
        variant="v2"
        disabled={isRequestLoading}
        onClick={handleOpen}
      >
        {isBroker ? 'edit' : 'associate'}
      </Button>
      <Modal
        title={`Associate with a broker`}
        open={isOpen}
        // onCancel={handleClose}
      >
        <BrokerAssignForm
          projectUuid={projectUuid} onClose={handleClose}
          // broker={broker}
          org={org} members={members}
        />
      </Modal>
    </AssignRoleController>
  )
}

const DisplayID = ({displayId}: DisplayIDProps) => (
  <Text uppercase spacing size="2xs" weight="demiBold" color="grey">
    ID {displayId}
  </Text>
)

const XeroButton = ({projectUuid}: any) => {
  const {mutate: syncProjectXero, isMutating: isSyncProjectXeroMutating} =
    useSyncProjectXero(projectUuid)

  const handleSync = () => syncProjectXero()

  return (
    <Confirm
      title="Are you sure you want to sync the project transactions with Xero?"
      onConfirm={handleSync}
    >
      <IconButton
        className={styles.xeroButton}
        loading={isSyncProjectXeroMutating}
        icon={<img width={58} height={14} src={xeroImg} alt="Xero" />}
      />
    </Confirm>
  )
}

const BorrowerAssign = ({projectUuid, isRequestLoading, org, members, request}: any) => {
  const isBorrowerAssignOpen = useStore((state) => state.isBorrowerAssignOpen)
  const setBorrowerAssignOpen = useStore((state) => state.setBorrowerAssignOpen)
  const handleOpen = () => setBorrowerAssignOpen(true)
  const handleClose = () => setBorrowerAssignOpen(false)

  return (
    <AssignRoleController request={request}>
      <Button
        variant="v2"
        disabled={isRequestLoading}
        onClick={handleOpen}
      >
        associate
      </Button>
      <Modal
        title="Associate with a borrower"
        open={isBorrowerAssignOpen}
        // onCancel={handleClose}
      >
        <BorrowerAssignForm
          projectUuid={projectUuid} onClose={handleClose} 
          org={org} members={members}
        />
      </Modal>
    </AssignRoleController>
  )
}
